import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  AttributeDateFromChanged,
  AttributeDateUntilChanged,
  AttributeNameChanged,
  AttributeTypeChanged,
  AttributeValueChanged,
  BoolAttributeValueChanged,
  ClearAttributeDateFrom,
  ClearAttributeDateUntil,
  ClearCustomerFilters,
  EmailChanged,
  FirstNameChanged,
  GetAttributeCodesSuccess,
  GetLoyaltyMembersSuccess,
  IncludeInactiveChanged,
  LastNameChanged,
  MainPanelStatusChanged,
  MemberTagChanged,
  MobileChanged,
  OtherPanelStatusChanged,
  PersonalPanelStatusChanged,
  QivosIDChanged,
  RegistrationDateFromChanged,
  RegistrationDateFromCleared,
  RegistrationDateUntilChanged,
  RegistrationDateUntilCleared,
} from '../actions/all-customers.actions';
import { AllCustomersState } from '../models/all-customers.models';

const initialState: AllCustomersState = {
  mainPanelExpanded: true,
  personalPanelExpanded: true,
  otherPanelExpanded: false,
  registrationDateFrom: '',
  registrationDateUntil: '',
  firstName: '',
  email: '',
  lastName: '',
  mobile: '',
  memberTagOptions: [],
  memberTag: 0,
  qivosID: '',
  attributes: [],
  attributeTypeOptions: ['INTEGER', 'STRING', 'BOOLEAN', 'DATE'],
  attributeType: '',
  attributeNameOptions: [],
  attributeName: '',
  attributeValue: '',
  attributeBoolValue: false,
  attributeDateFrom: '',
  attributeDateUntil: '',
  includeInactive: false,
};

export const AllCustomersReducer = createReducer(
  initialState,
  //   on(GetPointSourcesSuccess, (state, { res }) => ({
  //   ...state,
  //   countryOptions: res,
  // })),
  on(GetLoyaltyMembersSuccess, (state, { res }) => ({
    ...state,
    memberTagOptions: res,
  })),
  //   on(GetCouponsetSuccess, (state, { res }) => ({
  //   ...state,
  //   couponset: res,
  // })),
  //   on(GetStatusesSuccess, (state, { res }) => ({
  //   ...state,
  //   sta: res,
  // })),
  on(GetAttributeCodesSuccess, (state, { res }) => ({
    ...state,
    attributes: res.payload.data,
  })),
  on(MainPanelStatusChanged, (state) => ({
    ...state,
    mainPanelExpanded: !state.mainPanelExpanded,
  })),
  on(OtherPanelStatusChanged, (state) => ({
    ...state,
    otherPanelExpanded: !state.otherPanelExpanded,
  })),
  on(PersonalPanelStatusChanged, (state) => ({
    ...state,
    personalPanelExpanded: !state.personalPanelExpanded,
  })),
  on(RegistrationDateFromChanged, (state, { registrationDateFrom }) => ({
    ...state,
    registrationDateFrom,
  })),
  on(RegistrationDateUntilChanged, (state, { registrationDateUntil }) => ({
    ...state,
    registrationDateUntil,
  })),
  on(RegistrationDateFromCleared, (state) => ({
    ...state,
    registrationDateFrom: '',
  })),
  on(RegistrationDateUntilCleared, (state) => ({
    ...state,
    registrationDateUntil: '',
  })),
  on(LastNameChanged, (state, { lastName }) => ({
    ...state,
    lastName,
  })),
  on(FirstNameChanged, (state, { firstName }) => ({
    ...state,
    firstName,
  })),
  on(EmailChanged, (state, { email }) => ({
    ...state,
    email,
  })),
  on(MobileChanged, (state, { mobile }) => ({
    ...state,
    mobile,
  })),
  on(MemberTagChanged, (state, { memberTag }) => ({
    ...state,
    memberTag,
  })),
  on(QivosIDChanged, (state, { qivosID }) => ({
    ...state,
    qivosID,
  })),
  on(AttributeTypeChanged, (state, { attributeType }) => ({
    ...state,
    attributeType,
    attributeNameOptions:
      state.attributes?.attributeCodes?.find((attribute: any) => attribute.attributeType === attributeType)
        ?.attributeNames ?? [],
    attributeName: '',
    attributeBoolValue: false,
    attributeValue: '',
    attributeDateFrom: '',
    attributeDateUntil: '',
  })),
  on(AttributeNameChanged, (state, { attributeName }) => ({
    ...state,
    attributeName,
    attributeBoolValue: false,
    attributeValue: '',
    attributeDateFrom: '',
    attributeDateUntil: '',
  })),
  on(AttributeValueChanged, (state, { attributeValue }) => ({
    ...state,
    attributeValue,
  })),
  on(BoolAttributeValueChanged, (state) => ({
    ...state,
    attributeBoolValue: !state.attributeBoolValue,
  })),
  on(AttributeDateFromChanged, (state, { attributeDateFrom }) => ({
    ...state,
    attributeDateFrom,
  })),
  on(AttributeDateUntilChanged, (state, { attributeDateUntil }) => ({
    ...state,
    attributeDateUntil,
  })),
  on(ClearAttributeDateFrom, (state) => ({
    ...state,
    attributeDateFrom: '',
  })),
  on(ClearAttributeDateUntil, (state) => ({
    ...state,
    attributeDateUntil: '',
  })),
  on(IncludeInactiveChanged, (state) => ({
    ...state,
    includeInactive: !state.includeInactive,
  })),
  on(ActiveComponentChanged, (state, { activeComponent }) =>
    activeComponent === 'AllCustomersComponent' || activeComponent === 'MemberSearchComponent'
      ? {
          ...state,
        }
      : { ...initialState },
  ),
  on(ClearCustomerFilters, (state) => ({
    ...state,
    mainPanelExpanded: true,
    registrationDateFrom: '',
    registrationDateUntil: '',
    firstName: '',
    email: '',
    lastName: '',
    mobile: '',
    memberTag: 0,
    qivosID: '',
    attributeType: '',
    attributeName: '',
    attributeValue: '',
    attributeDateFrom: '',
    attributeDateUntil: '',
    includeInactive: false,
  })),
);
